import React from 'react'

import { Box } from 'components/layout/Box/Box'
import { Step } from './common/Step/Step'

import styles from './ProgressWidget.module.scss'

type ProgressWidgetProps = {
  steps?: unknown[]
  progress?: number
  label?: React.ReactNode
  queries?: ((state: unknown) => unknown) | null
  tabs?: ((index: unknown) => unknown) | null
  onClick?: (...args: unknown[]) => void
}

export const ProgressWidget = ({
  steps = [],
  progress = 0,
  label = '',
  queries = null,
  tabs = null,
  onClick,
}: ProgressWidgetProps) => (
  <Box
    align="center"
    className={styles.widget}
    direction="column"
    tagName="span"
  >
    <Box
      align="center"
      className={styles.steps}
      justify="center"
      tagName="span"
    >
      {steps.map((title, idx) => {
        const activeTab = tabs?.(idx)
        const query = queries?.({ activeTab })

        return (
          <Step
            className={styles.step}
            key={idx}
            title={title}
            isIncomplete={idx >= progress}
            onClick={onClick ? () => onClick(activeTab, query) : null}
          />
        )
      })}
    </Box>
    <span className={styles.label}>{label}</span>
  </Box>
)
